// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type {
  VirtualMachineExtensionImagesListTypesOptionalParams,
  VirtualMachineExtensionImagesListTypesResponse,
  VirtualMachineExtensionImagesListVersionsOptionalParams,
  VirtualMachineExtensionImagesListVersionsResponse,
  VirtualMachineExtensionImagesGetOptionalParams,
  VirtualMachineExtensionImagesGetResponse,
} from "../models/index.js";

/** Interface representing a VirtualMachineExtensionImages. */
export interface VirtualMachineExtensionImages {
  /**
   * Gets a list of virtual machine extension image types.
   * @param location The name of Azure region.
   * @param publisherName
   * @param options The options parameters.
   */
  listTypes(
    location: string,
    publisherName: string,
    options?: VirtualMachineExtensionImagesListTypesOptionalParams,
  ): Promise<VirtualMachineExtensionImagesListTypesResponse>;
  /**
   * Gets a list of virtual machine extension image versions.
   * @param location The name of Azure region.
   * @param publisherName
   * @param typeParam
   * @param options The options parameters.
   */
  listVersions(
    location: string,
    publisherName: string,
    typeParam: string,
    options?: VirtualMachineExtensionImagesListVersionsOptionalParams,
  ): Promise<VirtualMachineExtensionImagesListVersionsResponse>;
  /**
   * Gets a virtual machine extension image.
   * @param location The name of Azure region.
   * @param publisherName
   * @param typeParam
   * @param version
   * @param options The options parameters.
   */
  get(
    location: string,
    publisherName: string,
    typeParam: string,
    version: string,
    options?: VirtualMachineExtensionImagesGetOptionalParams,
  ): Promise<VirtualMachineExtensionImagesGetResponse>;
}
